import { ApiResponse } from 'apisauce';
import { restApi } from '../../services/api';
import { EmphasisCatalog, EmphasisCatalogSimple } from '../catalogs/catalog.types';

type BrandCatalogShowcaseRepositoryType = {
  synchronize: (data: EmphasisCatalogSimple[]) => Promise<ApiResponse<unknown>>;
  list: () => Promise<ApiResponse<{ data: EmphasisCatalog[] }>>;
};

export const brandCatalogShowcaseRepository = (
  brandId: string | undefined,
  isLoggedIn?: boolean,
): BrandCatalogShowcaseRepositoryType => {
  const repository = {
    synchronize: (data: EmphasisCatalogSimple[]) =>
      restApi.post(`showroom/catalog-showcase/synchronize`, data),
    list: () =>
      restApi.get<{ data: EmphasisCatalog[] }>(
        isLoggedIn
          ? `showroom/${brandId}/catalog-showcase?limit=1000`
          : `showroom/${brandId}/public-catalog-showcase?limit=1000`,
      ),
  };

  return repository;
};
